export default __webpack_public_path__ + "static/media/IMG-20210414-WA0022-01 - 5261_SAGAR SATAPATHY.2ddb0e9c.jpeg";